import React from 'react';
import moment from 'moment';
import { observer } from 'mobx-react';
import { Typography, Box } from '@material-ui/core';
import { useStores } from '../../hooks/use-stores';
import Loader from '../Loader';
import { useStyles } from './style';

const Points = observer(({ bottomBtn }) => {
    const classes = useStyles();
    const { LoyaltyStore: store } = useStores();
    const today = moment().format('DD.MM.YYYY');

    return (
        <Box className={classes.card}>
            <Typography className={classes.heading}>Ваши баллы на {today}</Typography>

            {store.loading && <Loader p={1} size={40} />}
            {!store.loading && <Typography className={classes.value}>{store.userLevelInfo?.points}</Typography>}
            {bottomBtn}
        </Box>
    );
});

export default Points;
